(function ($) {
  'use strict';

  /**
   * Marquee Scroll Animations (lax.js)[https://github.com/alexfoxy/lax.js]
   * - Adds marquee scroll animations to els with `data-marquee-dir` attr set.
   *   Use "from-start" & "from-end" to control animation direction:
   *   - data-marquee-dir="from-start"
   *   - data-marquee-dir="from-end"
   * - Disabled on mobile for performance
   * - Includes `rtl` support
   * - Respects user `prefers-reduced-motion` setting
   */

  var mql_reduced_motion = window.matchMedia( '(prefers-reduced-motion: reduce)' );
  var is_reduced_motion = mql_reduced_motion === true
    || mql_reduced_motion.matches === true;
  var is_rtl = document.dir === 'rtl';

  /**
   * Prep Text Marquee Scrolls
   */

  var $marquee_text_scrollers = $('.marquee-text[data-marquee-dir]');

  $marquee_text_scrollers.each(function () {
    var $this_text = $(this).find( '> span' );
    $this_text
      .after( $this_text.clone().attr( 'aria-hidden', 'true' ) )
      .before( $this_text.clone().attr( 'aria-hidden', 'true' ) );
  });


  /**
   * Handle Animations
   */

  window.onload = function () {

    /**
     * Animation Settings
     */

    var base_animate_start = -1200;
    var base_animate_end = base_animate_start / 4;

    // `ltr` animation direction by default
    var animate_x_from_start = [ base_animate_start, base_animate_end ];
    var animate_x_from_end = [ base_animate_end, base_animate_start ];

    // `rtl` animation direction
    // - Reverse animation directions for `rtl` support
    if ( is_rtl ) {
      animate_x_from_start = [ base_animate_end, base_animate_start ];
      animate_x_from_end = [ base_animate_start, base_animate_end ];
    }

    // Driver Map
    // - Defines type of animation
    var driver_map = [ 'elInY', 'elOutY' ];

    // Animation Map - Start > End (ltr)
    // - Defines how we're animating
    var animation_map_from_start = {
      // 759: [ 0, 0 ], // Disable for small screens
      // 760: animate_x_from_start, // Enable for large screens
      0: animate_x_from_start, // Enable for large screens
    };
    // Animation Map - End > Start (rtl)
    var animation_map_from_end = {
      // 759: [ 0, 0 ],
      // 760: animate_x_from_end,
      0: animate_x_from_end,
    };

    // Animation Options
    var animation_options = {
      // inertia - Adds scroll easing
      // inertia: 10,
      inertia: 0,
    };

    // Marquee Scroll Animation - ltr
    var marquee_from_start = {
      scrollY: {
        translateX: [
          driver_map,
          animation_map_from_start,
          animation_options,
        ],
      },
    };

    // Marquee Scroll Animation - rtl
    var marquee_from_end = {
      scrollY: {
        translateX: [
          driver_map,
          animation_map_from_end,
          animation_options,
        ],
      },
    };

    // Intial start values (ltr & rtl)
    var css_from_start = {
      style: {
        insetInlineStart: '0',
      }
    };
    var css_from_end = {
      style: {
        insetInlineEnd: '0',
      }
    };


    /**
     * Driver Init
     */

    // Driver Options
    var driver_options = {
      // Enable/Disable inertia
      inertiaEnabled: true,
    };

    // Init Lax
    lax.init();
    lax.addDriver('scrollY', function () {
      return window.scrollY;
    }, driver_options );


    /**
     * Apply animations to driver & els with data-attrs:
     * - [data-marquee-dir="from-start"]
     * - [data-marquee-dir="from-end"]
     */

    // Enable animations if reduced motion is _not_ disabled
    if ( ! is_reduced_motion ) {
      lax.addElements( '[data-marquee-dir="from-start"]', marquee_from_start, css_from_start );
      lax.addElements( '[data-marquee-dir="from-end"]', marquee_from_end, css_from_end );
    }

    // Toggle animations if reduced motion is changed after page load
    $(mql_reduced_motion).on('change', function (e) {
      is_reduced_motion = e.originalEvent === true
        || e.originalEvent.matches === true;

      if ( is_reduced_motion ) {
        lax.removeElements( '[data-marquee-dir="from-start"]' );
        lax.removeElements( '[data-marquee-dir="from-end"]' );
      } else {
        lax.addElements( '[data-marquee-dir="from-start"]', marquee_from_start, css_from_start );
        lax.addElements( '[data-marquee-dir="from-end"]', marquee_from_end, css_from_end );
      }
    });

  };

})(jQuery);
